// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y7cN","col":"styles_col__33uh-"};